import React from "react";
import { RichText } from "web/react/emo/rich-text/rich-text";
import * as styles from "./feature-article-rich-text.css";

interface FeatureArticleRichTextProps {
    children: string;
}

/**
 * The emo `RichText` with Feature Article markdown styling
 */
export function FeatureArticleRichText({
    children,
}: FeatureArticleRichTextProps): React.ReactElement {
    return (
        <RichText className={styles.richText} textStyle="body" color="secondary">
            {children}
        </RichText>
    );
}
